// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

// Styles
import '../styles/coloredTag.css';

export default class ColoredTag extends React.Component {
    render = () => {
        return (
            <div
                className='a'
                onClick={() => {
                    // Navigate to the props link 
                    window.location.href = this.props.link;
                }}
            >
                {this.props.label}
            </div>
        );
    }
}